import React from 'react';
import { FiltersGroup } from '@/components/uiKit/FiltersGroup';
import { FiltersValues } from '@/components/uiKit/FiltersGroup/types';
import {
  setCurrentFiltersData,
  setCurrentFiltersValues,
} from '@/store/slices/notificationPreferencesSlice/notificationPreferencesSlice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/store/store';
import { getNotificationPreferencesFiltersData } from '@/store/slices/notificationPreferencesSlice/utils';
import { shallowEqual } from 'react-redux';

export const NotificationPreferencesFilter = ({
  notificationPreferencesAssets,
}: {
  notificationPreferencesAssets: any;
}) => {
  const dispatch = useDispatch();

  const { currentFiltersValues, currentFiltersData, initialFiltersValues, allFiltersValues } = useSelector(
    (state: RootState) => ({
      currentFiltersValues: state.notificationPreferences.currentFiltersValues,
      currentFiltersData: state.notificationPreferences.currentFiltersData,
      initialFiltersValues: state.notificationPreferences.initialFiltersValues,
      allFiltersValues: state.notificationPreferences.allFiltersValues,
    }),
    shallowEqual
  );

  const handleFiltersValuesChange = React.useCallback(
    (filtersValues: FiltersValues) => {
      if (!allFiltersValues) return;

      const filtersData = getNotificationPreferencesFiltersData(
        notificationPreferencesAssets,
        filtersValues,
        allFiltersValues
      );

      dispatch(setCurrentFiltersValues(filtersValues));
      dispatch(setCurrentFiltersData(filtersData));
    },
    [dispatch, notificationPreferencesAssets, allFiltersValues]
  );

  if (!currentFiltersData || !allFiltersValues || !initialFiltersValues || !currentFiltersValues) {
    return null;
  }

  return (
    <FiltersGroup
      currentFiltersData={currentFiltersData}
      handleFiltersValuesChange={handleFiltersValuesChange}
      initialFiltersValues={initialFiltersValues}
      currentFiltersValues={currentFiltersValues}
      allFiltersValues={allFiltersValues}
    />
  );
};
